import React from 'react';
import {
  FieldErrors,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormWatch,
} from 'react-hook-form';
import { Step1BasicInfo } from './steps/RegistrationStep1BasicInfo';
import { Step2BusinessDetails } from './steps/RegistrationStep2BusinessDetails';
import { useNavigate } from 'react-router-dom';
import { VendorRegistrationPayload } from '@/schemas/registration.schema';

export interface VendorRegistrationFormProps {
  step: number;
  register: UseFormRegister<VendorRegistrationPayload>;
  errors: FieldErrors<VendorRegistrationPayload>;
  handleSubmit: UseFormHandleSubmit<VendorRegistrationPayload>;
  onSubmit: (data: VendorRegistrationPayload) => void;
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
  toggleCuisine: (cuisine: string) => void;
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  loading: boolean;
  getValues: UseFormGetValues<VendorRegistrationPayload>;
  watch: UseFormWatch<VendorRegistrationPayload>
}

const VendorRegistrationForm: React.FC<VendorRegistrationFormProps> = ({
  step,
  register,
  errors,
  watch,
  getValues,
  handleSubmit,
  onSubmit,
  showPassword,
  setShowPassword,

  toggleCuisine,
  handleNextStep,
  handlePreviousStep,
  loading,
}) => {

  const navigate = useNavigate()
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mt-8">
      {step === 1 && (
        <Step1BasicInfo
          register={register}
          errors={errors}
          getValues={getValues}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          handleNextStep={handleNextStep}
          onLogin={() => navigate("/login")}
        />
      )}

      {step === 2 && (
        <Step2BusinessDetails
          register={register}
          errors={errors}
          getValues={getValues}
          toggleCuisine={toggleCuisine}
          handlePreviousStep={handlePreviousStep}
          loading={loading}
          watch={watch}
        />
      )}
    </form>
  );
};

export default VendorRegistrationForm;
